import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  lastModified: '',
  lastRequestTime: null,
  multiCurrencyAccountsState: {
    isFetching: false,
    isFetched: false,
    isFailed: false,
    item: null,
    errorMessage: '',
  },
}

export const multiCurrencyAccountsSlice = createSlice({
  name: 'multiCurrencyAccounts',
  initialState: initialState,
  reducers: {
    getMultiCurrenciesRequest: (state: any) => {
      state.multiCurrencyAccountsState.isFetching = true
      state.multiCurrencyAccountsState.isFetched = false
      state.multiCurrencyAccountsState.isFailed = false
      state.multiCurrencyAccountsState.errorMessage = ''
    },
    getMultiCurrenciesSuccess: (state: any, action) => {
      state.multiCurrencyAccountsState.isFetching = false
      state.multiCurrencyAccountsState.isFetched = true
      state.multiCurrencyAccountsState.item = action.payload.item
    },
    getMultiCurrenciesFailure: (state: any, action) => {
      state.multiCurrencyAccountsState.isFetching = false
      state.multiCurrencyAccountsState.isFetched = true
      state.multiCurrencyAccountsState.isFailed = true
      state.multiCurrencyAccountsState.errorMessage =
        action.payload.errorMessage
    },
  },
})

export const {
  getMultiCurrenciesRequest,
  getMultiCurrenciesSuccess,
  getMultiCurrenciesFailure,
} = multiCurrencyAccountsSlice.actions

export default multiCurrencyAccountsSlice.reducer
